import { Stack, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC, ReactNode } from "react";
import { IconBox } from "web_myplann/Shared/Components/IconBox";

type Props = {
	icon: LucideIcon;
	iconBg: string;
	iconColor: string;
	children: ReactNode;
};

export const CenteredIconState: FC<Props> = ({
	icon: Icon,
	iconBg,
	iconColor,
	children,
}) => {
	const theme = useTheme();

	return (
		<Stack
			minHeight="100%"
			alignItems="center"
			justifyContent="center"
			textAlign="center"
			px={theme.spacingTokens.xxl}
		>
			<IconBox
				bg={iconBg}
				size={theme.iconBoxSize.xxl}
				borderRadius={theme.radii.xl}
				mb={theme.spacingTokens.section}
			>
				<Icon size={theme.iconSize.xxl} color={iconColor} />
			</IconBox>
			{children}
		</Stack>
	);
};
